import { Tab, Tabs } from "@nextui-org/react";
// import PaymentAccountProvider from "./paymentaccountprovider";
import PlayerList from "./playerlist";
// import SummaryTab from "./summary";
import SelfExclusionTab from "./selfExclusion";
import PartnershipList from "./Partnership";

const PlayerModuleTabs = () => {
  return (
    <div className="flex w-full flex-col justify-evenly">
      <Tabs
        variant="underlined"
        aria-label="Player Module"
        className="w-full justify-start"
        classNames={{
          tabList: ["overflow-x-auto text-[#FFFFFF80]"],
          cursor: "user-module-selected",
          tabContent:
            "text-base font-bold group-data-[selected=true]:text-[#FFFFFF]",
        }}
      >
        <Tab key="playerlist" title="Player List">
          <PlayerList />
        </Tab>
        {/* <Tab key="paymentaccountprovider" title="Payment Account Provider"> */}
        {/*   <PaymentAccountProvider /> */}
        {/* </Tab> */}
        {/* <Tab key="summary" title="Summary"> */}
        {/*   <SummaryTab /> */}
        {/* </Tab> */}
        <Tab key="Partnership" title="Partnership">
          <PartnershipList />
        </Tab>
        {/* <Tab key="selfExclusion" title="Self Exclusion"> */}
        {/*   <SelfExclusionTab /> */}
        {/* </Tab> */}
      </Tabs>
    </div>
  );
};

export default PlayerModuleTabs;
